import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, Modal, Spin, Result } from 'antd';
import api from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';

import style from './price.module.css';
import {useNavigate} from "react-router-dom";

const PricePage = () => {
    const [priceList, setPriceList] = useState({});
    const [selectedPlan, setSelectedPlan] = useState('free'); // 初始选择免费计划
    const [imageData, setImageData] = useState('');
    const [spinning, setSpinning] = useState(false);
    const [payStatus, setPayStatus] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isModalOpenRef = useRef(false);
    const { token, fetchUserInfo } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getVipData()
    }, [])

    const handleCardClick  = useCallback((key) => {
        if(selectedPlan !== key) {
            setSelectedPlan(key);
        }
    })

    const getVipData = async () => {
        const res = await api.get('/wxpay/vipData')
        console.log('res', res)
        setPriceList(res.data.data)
    }

    const showModal = async (key) => {
        console.log(key);
        if(key === 'free') {
            navigate(-1);
            return;
        }
        setSelectedPlan(key);
        // 正式版为 "release"，体验版为 "trial"，开发版为 "develop"。默认是正式版。
        const env_version = process.env.REACT_APP_ENV_VERSION;
        const res = await api.get(`/wxpay/qrcode?env_version=${env_version}&selectedPlan=${key}`)
        setImageData(res.data.data.qrcode)
        setIsModalOpen((prev) => {
            isModalOpenRef.current = !prev;
            return  isModalOpenRef.current;
        });
        setTimeout(() => {
            getOrderState(res.data.data.orderId)
        }, 1000)
    };

    const getOrderState = async (orderId) => {
     const res = await api.get('/wxpay/queryOrder', {
        params: {orderId: orderId}
     })
     console.log('isModalOpen', isModalOpenRef.current)
     setPayStatus(res.data.data.status)
     setSpinning(res.data.data.status === 'PAYING');
     if(res.data.data.status === 'SUCCESS') {
        setSpinning(false);
        fetchUserInfo(token);
     } else if(['WAITING', 'PAYING'].includes(res.data.data.status) && isModalOpenRef.current) {
            setTimeout(() => {
                getOrderState(orderId)
            }, 1000)
     }
    }

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen((prev) => {
            isModalOpenRef.current =!prev;
            return  isModalOpenRef.current;
        });
        setPayStatus('');
        setImageData('');
    };

  return (
    <div>
    <div className={style.pricingCards}>
    {Object.keys(priceList).map((key, index) => (
        <div className={`${style.pricingCard} ${selectedPlan === key ? style.featured : ''}`}  onClick={() => handleCardClick (key)} key={key}>
            <h2 className={style.cardTitle}>{priceList[key].title}</h2>
            <ul className={style.featureList}>
                {priceList[key].features.map((feature, i) => (<li key={i}>
                    <span className={style.checkIcon}>✓</span>
                    <span>{feature}</span>
                </li>))}
            </ul>
            <div className={style.priceSection}>
                <div className={style.divider}></div>
                <div className={style.priceContainer}>
                    <span className={style.price}>¥{priceList[key].price}</span>
                    <span className={style.pricePeriod}>/{priceList[key].period}</span>
                </div>
                <a href="#" className={`${style.ctaButton} ${selectedPlan === key ? style.secondary : style.primary}`} onClick={() => showModal(key)}>{priceList[key].cta}</a>
            </div>
        </div>
        ))}
    </div>
    <Modal title="请使用微信扫码支付" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} centered={true} keyboard={false} maskClosable={false} footer={null}>
        <Spin tip="Loading" spinning={spinning}>
            <div className={style.modelContainer}>
                { ['WAITING', "PAYING", ""].includes(payStatus) ? <img src={imageData} alt="二维码" /> : <Result
                    status="success"
                    title="支付成功"
                />}
                <div className={style.modelButton}>
                    { payStatus === 'SUCCESS' ? <><Button type="primary" onClick={handleCancel}>已经支付完成</Button></> : payStatus === 'WAITING' ? <><Button type="primary">已经支付完成</Button>
                    <Button onClick={handleCancel}>取消支付</Button></> : <Button type="primary">正在支付...</Button>}
                </div>
            </div>
        </Spin>
      </Modal>
    </div>
  )
}

export default PricePage;